import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Header } from "~/components/header";
import { getNavbarLinks } from "~/lib/constants/navbar";

export const Route = createFileRoute("/(chat)")({
  component: ChatLayout,
});

// App-shell layout: site header on top, chat fills the rest of the viewport.
// The welcome panel and conversation scroll independently of the shared header.
// The active conversation keeps its composer visible at the bottom.
function ChatLayout() {
  return (
    <div className="chat-page">
      <Header links={getNavbarLinks()} />
      <main className="chat-main" id="main">
        <Outlet />
      </main>
    </div>
  );
}
